import { render, staticRenderFns } from "./FormSelectField.vue?vue&type=template&id=ddea5b94&"
import script from "./FormSelectField.vue?vue&type=script&lang=js&"
export * from "./FormSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports